module.exports = __webpack_public_path__ + "static/media/canada1.7c877255.jpg";